import { render, staticRenderFns } from "./InvitationFlow.vue?vue&type=template&id=56fc696c&"
import script from "./InvitationFlow.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InvitationFlow.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./InvitationFlow.vue?vue&type=style&index=0&id=56fc696c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports